(() => {
  const root = window.Shopify?.routes?.root || '/';
  const menus = [...document.querySelectorAll('.rr-mega')];
  const positionMenu = () => document.documentElement.style.setProperty('--rr-menu-top', `${document.querySelector('.rr-header').getBoundingClientRect().bottom}px`);
  window.addEventListener('resize', positionMenu, { passive: true });
  window.addEventListener('scroll', () => { if (menus.some(menu => menu.open)) positionMenu(); }, { passive: true });
  menus.forEach(menu => menu.addEventListener('toggle', () => {
    if (!menu.open) return;
    positionMenu();
    menus.forEach(other => { if (other !== menu) other.open = false; });
  }));
  document.addEventListener('click', event => {
    if (!event.target.closest('.rr-mega,[data-open-brands]')) menus.forEach(menu => { menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const opened = menus.find(menu => menu.open);
    if (opened) { opened.open = false; opened.querySelector('summary').focus(); }
  });
  document.querySelectorAll('.rr-bike-browser').forEach(browser => {
    const models = [...browser.querySelectorAll('.rr-bike-model')];
    const modelList = document.createElement('div'); modelList.className = 'rr-bike-model-list';
    const panelHost = document.createElement('div'); panelHost.className = 'rr-bike-panel-host';
    const panes = new Map(models.map(model => [model, model.querySelector('.rr-bike-model__pane')]));
    const wide = matchMedia('(min-width: 761px)');
    const headerBrowser = Boolean(browser.closest('#rr-bike-menu'));
    let chosenHeaderModel = null;
    models.forEach(model => model.querySelector('summary').addEventListener('click', event => {
      if (headerBrowser) chosenHeaderModel = wide.matches || !model.open ? model : null;
      if (wide.matches && model.open) event.preventDefault();
    }));
    const arrange = () => {
      if (wide.matches) {
        if (!browser.classList.contains('rr-enhanced')) {
          [...browser.children].forEach(child => modelList.append(child));
          browser.append(modelList, panelHost); browser.classList.add('rr-enhanced');
          panes.forEach(pane => panelHost.append(pane));
        }
        if (!models.some(model => model.open) && models.length) models[0].open = true;
        panes.forEach((pane, model) => { pane.hidden = !model.open; });
      } else {
        if (browser.classList.contains('rr-enhanced')) {
          panes.forEach((pane, model) => { model.append(pane); pane.hidden = false; });
          [...modelList.children].forEach(child => browser.append(child));
          modelList.remove(); panelHost.remove(); browser.classList.remove('rr-enhanced');
        }
        if (headerBrowser) models.forEach(model => { model.open = model === chosenHeaderModel; });
      }
    };
    arrange(); wide.addEventListener('change', arrange);
    models.forEach(model => model.addEventListener('toggle', () => {
      if (model.open) models.forEach(other => { if (other !== model) other.open = false; });
      if (wide.matches) panes.forEach((pane, item) => { pane.hidden = !item.open; });
    }));
  });
  document.querySelectorAll('[data-bike-finder]').forEach(form => {
    const select = form.querySelector('select');
    try { const remembered = localStorage.getItem('riot-bike-model'); if ([...select.options].some(o => o.value === remembered)) select.value = remembered; } catch (_) {}
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const destination = select.value;
      if (!destination.startsWith('/collections/')) return;
      try { localStorage.setItem('riot-bike-model', destination); } catch (_) {}
      window.location.assign(destination);
    });
  });
  const initializedProductTabs = new WeakSet();
  const productTabActivators = new WeakMap();
  const findWithin = (scope, selector) => [
    ...(scope.matches?.(selector) ? [scope] : []),
    ...scope.querySelectorAll(selector)
  ];
  const initializeProductTabs = scope => findWithin(scope, '[data-product-tabs]').forEach(section => {
    if (initializedProductTabs.has(section)) return;
    const tabs = [...section.querySelectorAll('[data-tab-target]')];
    const tabList = section.querySelector('.rr-product-tabs');
    if (!tabs.length || !tabList) return;
    initializedProductTabs.add(section);
    section.classList.add('rr-tabs-ready'); tabList.setAttribute('role', 'tablist');
    const activate = active => tabs.forEach(tab => {
      const selected = tab === active;
      const panel = document.getElementById(tab.dataset.tabTarget);
      tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1;
      if (panel) panel.hidden = !selected;
    });
    tabs.forEach((tab, i) => {
      const panel = document.getElementById(tab.dataset.tabTarget);
      tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', tab.dataset.tabTarget);
      if (panel) { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tab.id); }
      tab.addEventListener('click', event => { event.preventDefault(); activate(tab); });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (event.key === 'ArrowLeft') next = tabs[(i + tabs.length - 1) % tabs.length];
        if (event.key === 'Home') next = tabs[0];
        if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) { event.preventDefault(); activate(next); next.focus(); }
      });
    });
    productTabActivators.set(section, activate);
    activate(tabs[0]);
  });
  initializeProductTabs(document);
  document.addEventListener('shopify:section:load', event => initializeProductTabs(event.target));
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('.rr-tab-panel');
    const section = panel?.closest('[data-product-tabs]');
    if (!section) return;
    initializeProductTabs(section);
    const tab = [...section.querySelectorAll('[data-tab-target]')].find(item => item.dataset.tabTarget === panel.id);
    if (tab) productTabActivators.get(section)?.(tab);
  });
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!event.target.closest('[data-open-brands]')) return;
    const menu = document.getElementById('rr-brand-menu');
    if (!menu) return;
    event.preventDefault(); menu.open = true; menu.querySelector('summary').focus(); positionMenu();
  });
  const form = document.querySelector('[data-predictive-form]');
  const box = document.getElementById('rr-predictive-results');
  if (form && box) {
    const input = form.querySelector('input[type=search]');
    let timer, controller, serial = 0;
    const close = () => {
      clearTimeout(timer);
      serial += 1;
      controller?.abort();
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };
    input.addEventListener('input', () => {
      clearTimeout(timer); controller?.abort(); const requestId = ++serial;
      const query = input.value.trim();
      if (query.length < 2) { close(); return; }
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const url = new URL(form.dataset.endpoint || `${root}search/suggest`, location.origin);
          url.search = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '5', section_id: 'rr-predictive-search' });
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Search unavailable');
          const html = await response.text();
          if (requestId !== serial) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const content = doc.querySelector('.rr-predictive-inner');
          if (!content) { close(); return; }
          box.replaceChildren(document.importNode(content, true)); box.hidden = false; input.setAttribute('aria-expanded', 'true');
        } catch (_) { if (requestId === serial) close(); }
      }, 220);
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') { close(); return; }
      if (event.key === 'ArrowDown' && !box.hidden) { event.preventDefault(); box.querySelector('a')?.focus(); }
    });
    box.addEventListener('keydown', event => {
      const links = [...box.querySelectorAll('a')]; const i = links.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') { event.preventDefault(); links[Math.min(i + 1, links.length - 1)]?.focus(); }
      if (event.key === 'ArrowUp') { event.preventDefault(); if (i <= 0) input.focus(); else links[i - 1].focus(); }
      if (event.key === 'Escape') { close(); input.focus(); }
    });
    document.addEventListener('click', event => { if (!event.target.closest('.rr-search-shell')) close(); });
  }
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const observedReveals = new WeakSet();
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('rr-reveal'); observer.unobserve(entry.target); } }), { threshold: .1 });
    const initializeReveals = scope => findWithin(scope, '.rr-model-tile,.rr-department').forEach(element => {
      if (observedReveals.has(element)) return;
      observedReveals.add(element);
      observer.observe(element);
    });
    initializeReveals(document);
    document.addEventListener('shopify:section:load', event => initializeReveals(event.target));
    document.addEventListener('shopify:section:unload', event => {
      findWithin(event.target, '.rr-model-tile,.rr-department').forEach(element => {
        observer.unobserve(element);
        observedReveals.delete(element);
      });
    });
  }
})();
